module.exports = __webpack_public_path__ + "static/media/video_hotspot.6fc37716.svg";